import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import dompurify from "isomorphic-dompurify";
import { Txt, useTranslations } from "@jti/ui";
import { useAemModel } from "../../contexts/AemModelContext";
import { LOYALTY_CHOICE } from "../../hooks/useLoyalty";
import styles from "./SummaryLoyaltyPoints.module.scss";
const { sanitize } = dompurify;
export const SummaryLoyaltyPoints = (props) => {
    const { __ } = useTranslations();
    const { totalLoyaltyPoints, loyaltyChoice } = props;
    const aemModel = useAemModel();
    if (loyaltyChoice === LOYALTY_CHOICE.COLLECT && totalLoyaltyPoints) {
        return (_jsx(Txt, { className: styles.loyaltyPrice, variant: "txt-3", children: __("cart.ploom_club.pointsBlock.collect_message", [totalLoyaltyPoints || ""]) }));
    }
    return (_jsxs("div", { className: styles.loyaltyPriceWrapper, children: [_jsx("div", { "data-testid": "noPointsMessage", dangerouslySetInnerHTML: {
                    __html: sanitize(__("loyalty.checkout.noPointsMessage")),
                }, className: styles.loyaltyPrice }), aemModel?.loyalty?.learnMoreUrl ? (_jsx("a", { href: aemModel.loyalty.learnMoreUrl, className: styles.loyaltyUrl, target: "_blank", rel: "noopener noreferrer", children: __("loyalty.checkout.learnMore") })) : null] }));
};
//# sourceMappingURL=SummaryLoyaltyPoints.js.map